import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getEmployeeProjects } from '../../../redux/MainAction';
import PaginationComponent from '../filters/PaginationComponent';
import moment from 'moment';

const EmployeeProjectsList = ({ data }) => {
  const dispatch = useDispatch();
  const projList = useSelector((state) => state?.Webtracker?.employeeProjects);

  const [projects, setProjectList] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const itemsPerPage = 10;

  useEffect(() => {
    getList();
  }, [page]);

  const getList = () => {
    var data2 = {
      offset: (page - 1) * itemsPerPage,
      limit: itemsPerPage,
      ownerId: localStorage.getItem('ownerId'),
    };
    dispatch(getEmployeeProjects(data2));
  };

  useEffect(() => {
    if (projList?.rows && projList?.count) {
      setProjectList(projList?.rows);
      setTotalPages(Math.ceil(projList.count / itemsPerPage));
    }
  }, [projList, page]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  return (
    <div className="mt-3">
      <div>
        <table
          id="datatable"
          className="table dt-responsive nowrap table-vertical"
          width="100%"
          cellSpacing="0"
        >
          <thead>
            <tr>
              <th>No.</th>
              <th>Project</th>
              <th>Project ID</th>
              <th>Members</th>
              <th>Hours Spent</th>
              <th>Created At</th>
            </tr>
          </thead>
          <tbody>
            {projects?.map((prj, idx) => (
              <tr key={idx}>
                <td>{idx + 1 + (page - 1) * itemsPerPage}</td>
                <td>{prj?.name}</td>
                <td>{prj?.projectId}</td>
                <td>{prj?.projectMembers?.length}</td>
                <td>{prj?.weeklyLimitPerMember}</td>
                <td>{moment(prj?.createdAt).format('Do MMM, YY')}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <PaginationComponent
          count={totalPages}
          page={page}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default EmployeeProjectsList;
